import config from '../config';
import {ERROR} from "./messages";
import {SET_ACCOUNTS} from "./accounts";
import {push} from "connected-react-router";

export const SET_USER = 'user/SET_USER'
export const CLEAR = 'user/CLEAR'

const initialState = {
    //username:"foo"
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_USER:
            let nstate = {
                ...state,
                ...action.data
            };
            return nstate;
        case CLEAR:
            return initialState;
        default:
            return state
    }
}

export const getAccounts = () => {
    return dispatch => {
        return fetch(`${config.host}/getAccounts`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(data => data.json())
            .then((json) => {
                if(json.error) {
                    dispatch(push('/login'));
                } else {
                    // if(json.status === 200) {
                    dispatch({
                        type: SET_USER,
                        data: {...json.user, socialUser: json.socialuser}
                    })
                    dispatch({
                        type: SET_ACCOUNTS,
                        data: json.sostreams
                    })

                    if (!json.user) {
                        dispatch(push('/login'));
                    }
                }
            })
            .catch((e) => {
                console.error(e);
            });
    }
}

export const logout = () => {
    return dispatch => {
        fetch(`${config.host}/signout`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then((response) => {
                dispatch({type:CLEAR})
                dispatch(push('/login'))
            })
            .catch((err) => {
                console.error(err);
            });
    }
}
export const login = ({username, password}) => {
    return dispatch => {
        fetch(`${config.host}/login/local`, {
            method: 'POST',
            body: JSON.stringify({
                username:username,
                password:password
            }),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(data => data.json())
            .then((json) => {

                    /*auth.authenticate(() => {
                        this.setState({ redirectToReferrer: true })
                    });*/
                dispatch({
                    type: SET_USER,
                    data:json
                })
                dispatch(push('/home'));
            })
            .catch((err) => {
                dispatch({
                    type:ERROR,
                    data:'Wrong username or password'
                })
            });
    }
}


// WEBPACK FOOTER //
// ./src/modules/user.js